import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/file.png'


const _withScopeId = n => (_pushScopeId("data-v-5c7597c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cv-add" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "我的简历", -1))
const _hoisted_3 = {
  key: 0,
  class: "df"
}
const _hoisted_4 = { class: "left-info" }
const _hoisted_5 = { class: "userinfo-top df jcsb" }
const _hoisted_6 = { class: "df" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "df aic" }
const _hoisted_9 = { class: "accountname-info weight-text" }
const _hoisted_10 = {
  class: "user-top-info",
  style: {"margin":"12px 0","text-align":"left"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = {
  class: "df aic",
  style: {"margin-top":"7px"}
}
const _hoisted_15 = {
  key: 0,
  class: "df aic",
  style: {"margin-right":"20px"}
}
const _hoisted_16 = { style: {"margin-left":"5px","color":"#1f2329"} }
const _hoisted_17 = {
  key: 1,
  class: "df aic"
}
const _hoisted_18 = { style: {"margin-left":"5px","color":"#1f2329"} }
const _hoisted_19 = {
  key: 0,
  style: {"position":"relative"}
}
const _hoisted_20 = {
  style: {"margin-bottom":"20px"},
  id: "basicU"
}
const _hoisted_21 = {
  style: {"margin-bottom":"20px"},
  id: "expectU"
}
const _hoisted_22 = {
  style: {"margin-bottom":"20px"},
  id: "workU"
}
const _hoisted_23 = {
  style: {"margin-bottom":"20px"},
  id: "projectU"
}
const _hoisted_24 = {
  style: {"margin-bottom":"20px"},
  id: "eduU"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "right-info" }
const _hoisted_28 = { class: "post-hr" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-head df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("div", { class: "info-head-title" }, [
    /*#__PURE__*/_createTextVNode(" 导入简历"),
    /*#__PURE__*/_createElementVNode("span", null, "(一键更新在线简历)")
  ])
], -1))
const _hoisted_30 = { class: "import-info" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1.请上传中文简历", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2.仅支持doc、docx、pdf格式", -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode("一键导入")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_35 = { class: "cv-file-name" }
const _hoisted_36 = { class: "cv-file-uploadtime" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-head df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("div", { class: "info-head-title" }, "简历目录")
], -1))
const _hoisted_38 = { class: "catalogue-info" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont if-of2-jibenxinxi1" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "基本信息", -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont if-of2-qiuzhiqiwang" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "求职期望", -1))
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont if-of2-gongzuojingli" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工作经历", -1))
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont if-of2-xiangmujingli" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "项目经历", -1))
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont if-of2-jiaoyujingli" }, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "教育经历", -1))
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iphone = _resolveComponent("iphone")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_message = _resolveComponent("message")!
  const _component_BasicInfo = _resolveComponent("BasicInfo")!
  const _component_Expect = _resolveComponent("Expect")!
  const _component_WorkExperience = _resolveComponent("WorkExperience")!
  const _component_ProjectExperience = _resolveComponent("ProjectExperience")!
  const _component_EduExperience = _resolveComponent("EduExperience")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_search = _resolveComponent("search")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_delete = _resolveComponent("delete")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_ViewPdf = _resolveComponent("ViewPdf")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_load = _resolveDirective("load")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (!_ctx.isInit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      class: "user-avatar",
                      src: 
                  _ctx.detail.headUrl ||
                  'https://image.offersaas.com/offercloud/2022/3/14/952879142695600128/defaultAvatar.png'
                ,
                      alt: ""
                    }, null, 8, _hoisted_7),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.detail.accountName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", null, _toDisplayString(Number(_ctx.detail.sex) !== -1 && _ctx.detail.sex !== null
                      ? Number(_ctx.detail.sex) === 1
                        ? "男"
                        : "女"
                      : "不详"), 1),
                        (_ctx.detail.workYears)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.detail.workYears) + "年经验", 1))
                          : _createCommentVNode("", true),
                        (_ctx.detail.lastEduCertText)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.detail.lastEduCertText), 1))
                          : _createCommentVNode("", true),
                        (_ctx.detail.age)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.detail.age) + "岁", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        (_ctx.detail.mobile)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_iphone)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.detail.mobile), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.detail.email)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_message)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.detail.email), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_component_el_tabs, {
                        modelValue: _ctx.activeName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeName) = $event)),
                        class: "demo-tabs",
                        onTabClick: _ctx.handleClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tab_pane, {
                            label: "标准简历",
                            name: "info"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_BasicInfo, {
                                  ref: "basicInfo",
                                  detail: _ctx.detail
                                }, null, 8, ["detail"])
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_Expect, {
                                  ref: "expect",
                                  detail: _ctx.detail
                                }, null, 8, ["detail"])
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_WorkExperience, {
                                  ref: "workExperience",
                                  detail: _ctx.detail
                                }, null, 8, ["detail"])
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_ProjectExperience, {
                                  ref: "projectExperience",
                                  detail: _ctx.detail
                                }, null, 8, ["detail"])
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_EduExperience, {
                                  ref: "eduExperience",
                                  detail: _ctx.detail
                                }, null, 8, ["detail"])
                              ])
                            ]),
                            _: 1
                          }),
                          (_ctx.detail.resumeUrl)
                            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                                key: 0,
                                label: "附件简历",
                                name: "cvfile"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.fileType === 'pdf')
                                    ? (_openBlock(), _createElementBlock("iframe", {
                                        key: 0,
                                        class: "detail-iframe2",
                                        src: _ctx.detail.resumeUrl,
                                        frameborder: "0"
                                      }, null, 8, _hoisted_25))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        style: {"text-align":"left","padding":"20px"},
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFile(_ctx.originalResumeUrl)))
                                      }, [
                                        _createElementVNode("div", {
                                          style: {"cursor":"pointer"},
                                          title: _ctx.getFileName(_ctx.originalResumeUrl)
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.getFileName(_ctx.originalResumeUrl)), 1)
                                        ], 8, _hoisted_26)
                                      ]))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onTabClick"]),
                      (_ctx.detail.resumeUrl && _ctx.fileType === 'pdf')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "aaaa",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toPdf && _ctx.toPdf(...args)))
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_search)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _hoisted_32,
                    _createVNode(_component_el_upload, {
                      ref: "resumeRef",
                      class: "upload-btn",
                      action: _ctx.action,
                      limit: 1,
                      accept: ".pdf,.doc,.docx",
                      "show-file-list": false,
                      "on-success": _ctx.handleSuccess,
                      "on-exceed": _ctx.handleExceed,
                      "on-remove": _ctx.handleRemove
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "import-btn",
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_33
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["action", "on-success", "on-exceed", "on-remove"]),
                    (_ctx.fileList.length > 0 && _ctx.fileUploadTime)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "cv-file-info",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toPdf && _ctx.toPdf(...args)))
                        }, [
                          _createVNode(_component_el_icon, {
                            onClick: _withModifiers(_ctx.handleRemove, ["stop"]),
                            class: "cv-delete-icon"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_delete)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _hoisted_34,
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.fileList[0].name), 1),
                            _createElementVNode("span", _hoisted_36, "上传时间：" + _toDisplayString(_ctx.$utils.dateFm(_ctx.fileUploadTime, "YYYY-MM-DD hh:mm")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_affix, { offset: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("a", {
                          class: _normalizeClass({ active: _ctx.activeIndex === 0 }),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeHash('basicU', 0)))
                        }, _hoisted_41, 2),
                        _createElementVNode("a", {
                          class: _normalizeClass({ active: _ctx.activeIndex === 1 }),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeHash('expectU', 1)))
                        }, _hoisted_44, 2),
                        _createElementVNode("a", {
                          class: _normalizeClass({ active: _ctx.activeIndex === 2 }),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeHash('workU', 2)))
                        }, _hoisted_47, 2),
                        _createElementVNode("a", {
                          class: _normalizeClass({ active: _ctx.activeIndex === 3 }),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeHash('projectU', 3)))
                        }, _hoisted_50, 2),
                        _createElementVNode("a", {
                          class: _normalizeClass({ active: _ctx.activeIndex === 4 }),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeHash('eduU', 4)))
                        }, _hoisted_53, 2)
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_load, _ctx.isLoading]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "查看附件",
      width: "1100px",
      top: "5vh",
      center: true,
      "destroy-on-close": true,
      "before-close": _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ViewPdf, {
          resumeUrl: _ctx.detail.resumeUrl
        }, null, 8, ["resumeUrl"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 64))
}